/**
 * Available API key scopes (one copy: the backend validates them, the admin UI offers them) for granular permission control
 *
 * Scopes follow the pattern: `<resource>:<action>`
 * - resource: transactions, reports, accounts, organizations, etc.
 * - action: read, write, delete, admin
 *
 * Examples:
 * - "transactions:read" - Read transaction data
 * - "transactions:write" - Create/update transactions
 * - "reports:read" - Access tax reports
 * - "admin:all" - Full administrative access
 */
export const API_KEY_SCOPES = {
  // Transaction scopes
  TRANSACTIONS_READ: 'transactions:read',
  TRANSACTIONS_WRITE: 'transactions:write',
  TRANSACTIONS_DELETE: 'transactions:delete',

  // Report scopes
  REPORTS_READ: 'reports:read',
  REPORTS_WRITE: 'reports:write',

  // Account scopes
  ACCOUNTS_READ: 'accounts:read',
  ACCOUNTS_WRITE: 'accounts:write',

  // Organization scopes
  ORG_READ: 'org:read',
  ORG_WRITE: 'org:write',

  // Admin scopes
  ADMIN_ALL: 'admin:all',

  // Webhook scopes
  WEBHOOKS_READ: 'webhooks:read',
  WEBHOOKS_WRITE: 'webhooks:write',

  // Import/Export scopes
  IMPORT_WRITE: 'import:write',
  EXPORT_READ: 'export:read',
} as const

export type ApiKeyScope = (typeof API_KEY_SCOPES)[keyof typeof API_KEY_SCOPES]
